export const MAP_GEOFENCES_BULK_OPEN_MODAL = "MAP_GEOFENCES_BULK_OPEN_MODAL";
export const MAP_GEOFENCES_BULK_UPDATE = "MAP_GEOFENCES_BULK_UPDATE";
export const MAP_GEOFENCES_BULK_UPDATE_RESPONSE = "MAP_GEOFENCES_BULK_UPDATE_RESPONSE";